import { Breadcrumbs } from "@/components/ui/breadcrumbs";
import { RFSEditForm } from "@/features/rfs/RFSEditForm";

export function RFSEdit() {
  return (
    <>
      <Breadcrumbs
        list={[
          {
            label: "RFS Submission",
          },
          {
            href: "/rfs/rfs",
            label: "RFS List",
          },
          {
            label: "Draft (Invalid Data)",
          },
        ]}
      />
      <RFSEditForm />
    </>
  );
}
